import LegalPage from "@/components/legal/LegalPage";

const Terms = () => <LegalPage slug="terms" />;

export default Terms;
